module.exports = __webpack_public_path__ + "files/376ffb0ecb0801fc1548ce35d636f96b.png";